import React from 'react';
import { AlignLeftOutlined } from '@ant-design/icons';
import ReactQuill from 'react-quill';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

const { Quill } = ReactQuill;

const fonts = ['arial', 'times', 'roboto'];

var Font = Quill.import('formats/font');
Font.whitelist = fonts;
Quill.register(Font, true);

const toolbarOptions = [
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    [{ 'font': fonts }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ 'color': [] }, { 'background': [] }, { 'align': [] }],
    ['blockquote', 'code-block', 'link'],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    [{ 'indent': '-1' }, { 'indent': '+1' }],
    [{ 'direction': 'rtl' }, 'clean'],
];

export default {
    Renderer: (props) => {
        const { data } = props;

        return (
            <ReactQuill
                bounds={".react-page-editable"}
                theme="bubble"
                value={data.content}
                onChange={(v) => {
                    props.onChange({ content: v });
                }}
                placeholder={t`Votre Texte Ici...`}
                modules={{
                    toolbar: toolbarOptions
                }}
                readOnly={props.readOnly}
            />
        );

    },
    id: 'text-quill',
    title: t`Texte`,
    description: t`Un éditeur de texte enrichi avancée.`,
    icon: <AlignLeftOutlined />,
    version: 1,
    allowClickInside: true
}
